export default "__VITE_ASSET__BPP8q4XD__"